import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Row } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit";
import moment from "moment";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

const AnnouncementsTable = ({
  tableData,
  defaultSorted,
  forceUpdate: _forceUpdate,
  setForce: _setForce,
  searchQuery,
  onView,
}) => {
  const { t } = useTranslation();
  const { ExportCSVButton } = CSVExport;

  const dismissedFormatter = (cell, row) => (
    <>
      {row.is_dismissed ? (
        <span className="text-success fas fa-check-circle" style={{ fontSize: "1.2rem" }} />
      ) : (
        <span className="text-danger fas fa-times-circle" style={{ fontSize: "1.2rem" }} />
      )}
    </>
  );

  const statusFormatter = (cell, row) => (
    <>
      {row.is_read ? (
        <Button className="btn-status-big" disabled color="success">
          {t("announcements.view.table.status.read")}
        </Button>
      ) : (
        <Button className="btn-status-big" disabled color="primary">
          {t("announcements.view.table.status.unread")}
        </Button>
      )}
    </>
  );

  const statusCsvFormatter = cell =>
    cell ? t("announcements.view.table.csv.statusRead") : t("announcements.view.table.csv.statusUnread");
  const dismissedCsvFormatter = cell =>
    cell
      ? t("announcements.view.table.csv.dismissedYes")
      : t("announcements.view.table.csv.dismissedNo");

  const dateFormatter = (cell, row) => {
    return (
      moment(cell).format("YYYY-MM-DD")
    );
  };

  const actionFormatter = (cell, row) => (
    <Button className="btn btn-outline-primary" onClick={() => onView(row)}>
      {t("announcements.view.table.action.view")}
    </Button>
  );

  const columns = [
    {
      dataField: "title",
      text: t("announcements.view.table.column.title"),
      sort: false,
      formatter: cell => <span className="fontWeight700">{cell || "—"}</span>,
      headerStyle: () => ({ width: "150px" }),
    },
    {
      dataField: "created",
      text: t("announcements.view.table.column.datePosted"),
      sort: false,
      formatter: dateFormatter,
      headerStyle: () => ({ width: "70px" }),
    },
    {
      dataField: "is_dismissed",
      text: t("announcements.view.table.column.dismissed"),
      sort: false,
      formatter: dismissedFormatter,
      csvFormatter: dismissedCsvFormatter,
      headerStyle: () => ({ width: "60px" }),
    },
    {
      dataField: "is_read",
      text: t("announcements.view.table.column.status"),
      sort: false,
      formatter: statusFormatter,
      csvFormatter: statusCsvFormatter,
      headerStyle: () => ({ width: "60px" }),
    },
    {
      dataField: "action",
      text: t("announcements.view.table.column.action"),
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: () => ({ width: "30px" }),
    },
  ];

  const handleTableChange = (type, { sortField, sortOrder }) => {
    const ascDesc = sortOrder === "desc" ? "-" : "";
    if (sortField === "title" || sortField === "created" || sortField === "is_read") {
      searchQuery.setOrdering({ order: ascDesc, name: sortField, sort: sortField });
    }
  };

  return (
    <ToolkitProvider
      keyField="tableKey"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true,
      }}
      exportCSV={{
        fileName: "announcements.csv",
      }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="flexEndContainer mb-3">
                <ExportCSVButton className="btn btn-outline-info" {...props.csvProps}>
                  {t("announcements.view.table.button.exportCsv")}
                </ExportCSVButton>
              </div>
            </Col>
          </Row>
          <BootstrapTable
            {...props.baseProps}
            bordered={false}
            defaultSorted={defaultSorted}
            remote={{ sort: true }}
            onTableChange={handleTableChange}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default AnnouncementsTable;
